import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useCreateTemplateReviewMutation({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (review: Api.ITemplateReviewRequest) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ templateId, reviewRequest }: { templateId: string; reviewRequest: Api.TemplateReviewRequest }) => {
			return userSession.webServiceHelper.callAsync<Api.ITemplateReviewRequest>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `template/${templateId}/review`,
				}),
				'POST',
				reviewRequest
			);
		},
		onError,
		onSuccess,
	});
}
